import { render } from "./BulkEditWrapper.vue?vue&type=template&id=0c51d43c"
import script from "./BulkEditWrapper.vue?vue&type=script&lang=js"
export * from "./BulkEditWrapper.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BulkEditWrapper.vue?vue&type=style&index=0&id=0c51d43c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__